// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Form, Col, Row, Table } from "react-bootstrap";
// import { IoMdClose } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import { BASE_URL } from "../../../services/Api";
// import { authHeader } from "../../../services/auth-header";

// const ViewAraiMFGSO = ({ enquiryData }) => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
//   const [productOptions, setProductOptions] = useState([]);
//   const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
//   const [customerDetailsOptions, setCustomerDetailsOptions] = useState();
//   const [branchOptions, setBranchOptions] = useState();
//   const [branchSearch, setBranchSearch] = useState(encodeURIComponent(" "));
//   const [warehouseOptions, setWarehouseOptions] = useState();
//   const [warehouseSearch, setWarehouseSearch] = useState(encodeURIComponent(" "));
//   const [staffOptions, setStaffOptions] = useState();
//   const [staffSearch, setStaffSearch] = useState(encodeURIComponent(" "));

//   const [customerAddressValue, setCustomerAddressValue] = useState();
//   const [branchValue, setBranchValue] = useState();
//   const [warehouseValue, setWarehouseValue] = useState();
//   const [customerNameValue, setCustomerNameValue] = useState();

//   const [enquiryDetails, setEnquiryDetails] = useState({
//     salesordertype: "Manufacturing",
//     salesordercategory: "International",
//     branch: "",
//     warehouse: "",
//     sodate: "",
//     amendmentno: "",
//     amendmentdate: "",
//     customer: "",
//     contactperson: "",
//     contactno: "",
//     email: "",
//     customeraddress: "",
//     customerpono: "",
//     customerpodate: "",
//     quotationno: "",
//     quotationdate: "",
//     netamountcurrency: "",
//     netamount: "",
//     exportpreperationchargescurrency: "",
//     exportpreperationcharges: "",
//     grandtotalcurrency: "",
//     grandtotalinr: "",
//     salesOrderItems: [],
//     socurrency: "",
//     soexchangerate: "",
//   });

//   console.log(enquiryData);

//   async function getBranchData() {
//     const response = await axios.get(`${BASE_URL}branch/page/0/5/asc/id/${branchSearch.length > 0 ? branchSearch : encodeURIComponent(" ")}`, {
//       headers: authHeader(),
//     });

//     console.log(response);
//     setBranchOptions(
//       response.data.Index
//         ? response.data.Index.map((customer) => ({
//           value: customer.id,
//           label: customer.branchname,
//         }))
//         : response.data.data.map((customer) => ({
//           value: customer.id,
//           label: customer.branchname,
//         }))
//     );
//   }

//   async function getWarehouseData() {
//     try {
//       const response = await axios.get(`${BASE_URL}warehouse/page/0/10/asc/id/${warehouseSearch.length > 0 ? warehouseSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });
//       console.log(response);
//       setWarehouseOptions(
//         response.data.Index
//           ? response.data.Index.map((customer) => ({
//             value: customer.id,
//             label: customer.warehousename,
//           }))
//           : response.data.data.map((customer) => ({
//             value: customer.id,
//             label: customer.warehousename,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getStaffData() {
//     try {
//       const response = await axios.get(`${BASE_URL}staff/page/0/10/asc/id/${staffSearch.length > 0 ? staffSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });
//       console.log(response);
//       setStaffOptions(
//         response.data.Index
//           ? response.data.Index.map((customer) => ({
//             value: customer.id,
//             label: customer.firstname + customer.lastname,
//           }))
//           : response.data.data.map((customer) => ({
//             value: customer.id,
//             label: customer.firstname + customer.lastname,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerData() {
//     try {
//       const response = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch.length > 0 ? customerSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });
//       setCustomerOptions(
//         response.data.Index
//           ? response.data.Index.map((customer) => ({
//             value: customer.id,
//             label: customer.companyname,
//           }))
//           : response.data.data.map((customer) => ({
//             value: customer.id,
//             label: customer.companyname,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getProductData() {
//     try {
//       const response = await axios.get(`${BASE_URL}product/page/international mfg/0/5/asc/id/${productSearch.length > 0 ? productSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });

//       setProductOptions(
//         response.data.Index
//           ? response.data.Index.map((product) => ({
//             value: product.id,
//             label: product.description,
//           }))
//           : response.data.data.map((product) => ({
//             value: product.id,
//             label: product.description,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerDetails(id) {
//     try {
//       const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
//         headers: authHeader(),
//       });
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customer: {
//           id: id,
//         },
//         contactperson: response.data.contactperson,
//         contactno: response.data.contactno,
//         email: response.data.email,
//         customeraddress: response.data.address,
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerAddress(id) {
//     try {
//       const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
//         headers: authHeader(),
//       });

//       console.log(response);
//       setCustomerDetailsOptions(response.data.map((data) => ({ value: data.id, label: data.customeraddress })));
//     } catch (error) { }
//   }

//   async function handleProductChange(event) {
//     try {
//       const response = await axios.get(`${BASE_URL}product/findById/${event.value}`, {
//         headers: authHeader(),
//       });

//       console.log(response);

//       let row = {
//         product: {
//           id: response.data.id,
//         },
//         description: response.data.description,
//         itemcode: response.data.itemcode,
//         hsnsacno: response.data.hsnsacno,
//         uom: response.data.unitofmeasurement,
//         currency: enquiryDetails?.socurrency,
//         quantity: "",
//         unitratecurrency: "",
//         totalcurrency: "",
//         exchangerate: enquiryDetails?.soexchangerate,
//         unitrateinr: "",
//         totalinr: "",
//       };

//       setEnquiryDetails({
//         ...enquiryDetails,
//         salesOrderItems: [...enquiryDetails.salesOrderItems, row],
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function handleSubmit(event) {
//     event.preventDefault();

//     try {
//       const response = await axios.put(`${BASE_URL}salesOrder/update/${id}`, enquiryDetails, {
//         headers: authHeader(),
//       });

//       Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: "Enquiry added successfully!",
//       });

//       navigate("/salesOrderIndexTable/1");
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   const handleFormChange = (event, element) => {
//     console.log("start");
//     if (element === "soexchangerate") {
//       let data = enquiryDetails;
//       data.soexchangerate = event.target.value;
//       const newItems = enquiryDetails.salesOrderItems.map((item) => ({
//         ...item,
//         exchangerate: event.target.value,
//       }));

//       data.salesOrderItems = newItems;
//       console.log("start");
//       setEnquiryDetails(data);
//       console.log("start");
//       calculationsBasedOnExchangeRate();
//       return;
//     }

//     if (element === "socurrency") {
//       const newItems = enquiryDetails.salesOrderItems.map((item) => ({
//         ...item,
//         currency: event.target.value, // Update currency for each item
//       }));

//       setEnquiryDetails({
//         ...enquiryDetails,
//         socurrency: event.target.value, // Update selected currency
//         salesOrderItems: newItems, // Update all item currencies
//       });
//       return;
//     }

//     if (element === "branch") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         branch: {
//           id: event.value,
//         },
//       });
//       setBranchValue(event);
//       return;
//     }

//     if (element === "billto") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         billto: {
//           id: event.value,
//         },
//       });
//       return;
//     }

//     if (element === "shipto") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         shipto: {
//           id: event.value,
//         },
//       });
//       return;
//     }

//     if (element === "copyto") {
//       let data = [];

//       for (let i = 0; i < event.length; i++) {
//         let obj = {
//           id: event[i].value,
//         };

//         data.push(obj);
//       }

//       setEnquiryDetails({
//         ...enquiryDetails,
//         copyto: data,
//       });
//       return;
//     }

//     if (element === "warehouse") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         warehouse: {
//           id: event.value,
//         },
//       });
//       setWarehouseValue(event);
//       return;
//     }

//     if (element === "manufacturedby") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         manufacturedby: event.value,
//       });
//       return;
//     }

//     if (element === "customer") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customer: {
//           id: event.value,
//         },
//       });
//       setCustomerNameValue(event);
//       getCustomerDetails(event.value);
//       getCustomerAddress(event.value);
//       setCustomerAddressValue("");
//       return;
//     }

//     if (element === "customeraddress") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customeraddress: {
//           id: event.value,
//         },
//       });
//       setCustomerAddressValue(event);
//       return;
//     }

//     const { name, value } = event.target;
//     setEnquiryDetails({
//       ...enquiryDetails,
//       [name]: value,
//     });
//   };

//   const handleGrandTotalCurrency = (netAmountCurrency, miscChargesCurrency) => {
//     const total = Number(netAmountCurrency) + Number(miscChargesCurrency);
//     console.log(total);

//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       grandtotalcurrency: total,
//     }));
//   };

//   const handleGrandTotalInr = (netAmountCurrency, miscChargesCurrency) => {
//     const total = Number(netAmountCurrency) + Number(miscChargesCurrency);
//     console.log(total);

//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       grandtotalinr: total,
//     }));
//   };

//   const calculationsBasedOnExchangeRate = () => {
//     let rows = enquiryDetails.salesOrderItems;

//     for (let i = 0; i < enquiryDetails.salesOrderItems.length; i++) {
//       rows[i].unitrateinr = rows[i].unitratecurrency * rows[i].exchangerate;
//       rows[i].totalinr = rows[i].unitrateinr * rows[i].quantity;
//     }

//     setEnquiryDetails({
//       ...enquiryDetails,
//       salesOrderItems: rows,
//     });

//     handleGrandTotal();
//   };

//   const handleNetTotalCurrency = () => {
//     let rows = enquiryDetails.salesOrderItems;
//     let netTotal = 0;

//     for (let i = 0; i < rows.length; i++) {
//       netTotal += rows[i].totalcurrency;
//     }

//     setEnquiryDetails({
//       ...enquiryDetails,
//       netamountcurrency: netTotal,
//     });
//   };

//   const handleQuantityChange = (event, index) => {
//     let rows = enquiryDetails.salesOrderItems;

//     enquiryDetails.netamount = 0;
//     rows[index].quantity = event.target.value;

//     rows[index].totalcurrency = Number(rows[index].quantity) * Number(rows[index].unitratecurrency);
//     rows[index].totalinr = Number(rows[index].quantity) * Number(rows[index].unitrateinr);

//     for (let i = 0; i < rows.length; i++) {
//       enquiryDetails.netamount += rows[i].totalinr;
//     }

//     setEnquiryDetails({
//       ...enquiryDetails,

//       salesOrderItems: rows,
//     });

//     handleNetTotalCurrency();
//   };

//   const handleUnitRateChange = (event, index) => {
//     let rows = enquiryDetails.salesOrderItems;
//     enquiryDetails.netamount = 0;

//     rows[index].unitratecurrency = event.target.value;
//     rows[index].unitrateinr = rows[index].unitratecurrency * rows[index].exchangerate;
//     rows[index].totalcurrency = Number(rows[index].quantity) * Number(rows[index].unitratecurrency);
//     rows[index].totalinr = Number(rows[index].quantity) * Number(rows[index].unitrateinr);
//     rows[index].totalinr = roundToDecimalPlaces(rows[index].totalinr, 2);

//     for (let i = 0; i < rows.length; i++) {
//       enquiryDetails.netamount += rows[i].totalinr;
//     }

//     setEnquiryDetails({
//       ...enquiryDetails,
//       salesOrderItems: rows,
//     });

//     handleGrandTotal();
//     handleNetTotalCurrency();
//   };

//   const handleExchangeRateChange = (event, index) => {
//     let rows = enquiryDetails.salesOrderItems;

//     rows[index].exchangerate = event.target.value;
//     rows[index].unitrateinr = rows[index].exchangerate * rows[index].unitratecurrency;
//     rows[index].totalinr = rows[index].unitrateinr * rows[index].quantity;

//     setEnquiryDetails({
//       ...enquiryDetails,
//       salesOrderItems: rows,
//     });

//     handleGrandTotal();
//   };

//   const handleGrandTotal = () => {
//     let nettotal = 0;

//     for (let i = 0; i < enquiryDetails.salesOrderItems.length; i++) {
//       nettotal += enquiryDetails.salesOrderItems[i].totalinr;
//     }

//     setEnquiryDetails({
//       ...enquiryDetails,
//       netamount: nettotal,
//     });
//   };

//   const handleMiscChargesCurrency = (event) => {
//     const updatedRows = {
//       ...enquiryDetails,
//       exportpreperationchargescurrency: event.target.value,
//       exportpreperationcharges: enquiryDetails.soexchangerate * event.target.value,
//     };
//     setEnquiryDetails(updatedRows);
//   };

//   function handleMiscCharges(event) {
//     console.log(event.target.value);
//     let miscCharges = parseFloat(event.target.value); // Convert to a number
//     console.log(miscCharges, enquiryDetails.gst);

//     const gstAmount = (miscCharges * Number(enquiryDetails.gst)) / 100; // Calculate GST
//     console.log(gstAmount);

//     let netCharges = miscCharges + gstAmount; // Correctly add as numbers
//     console.log(netCharges);

//     // Ensure netamount is a number before adding
//     let netamount = Number(enquiryDetails.netamount) || 0; // Default to 0 if undefined
//     let gtotal = roundToDecimalPlaces(netamount + netCharges, 2);

//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       exportpreperationcharges: miscCharges,
//       netcharges: netCharges,
//       grandtotalinr: gtotal,
//     }));
//   }

//   function roundToDecimalPlaces(value, decimalPlaces) {
//     const factor = Math.pow(10, decimalPlaces);
//     return Math.round(value * factor) / factor;
//   }

//   const removeRow = (idx) => {
//     // Filter out the item at the specified index
//     const newItems = enquiryDetails.salesOrderItems.filter((_, index) => index !== idx);

//     // Update state with the new items
//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       salesOrderItems: newItems,
//     }));

//     // Call handleGrandTotal to recalculate the grand total
//     // Pass the updated items
//   };

//   useEffect(() => {
//     getCustomerData();
//     getProductData();
//     getBranchData();
//     getWarehouseData();
//     getStaffData();
//   }, []);

//   useEffect(() => {
//     getCustomerData();
//   }, [customerSearch]);

//   useEffect(() => {
//     getProductData();
//   }, [productSearch]);

//   useEffect(() => {
//     getBranchData();
//   }, [branchSearch]);

//   useEffect(() => {
//     getWarehouseData();
//   }, [warehouseSearch]);

//   useEffect(() => {
//     getStaffData();
//   }, [staffSearch]);

//   //   useEffect(() => {
//   //     setEnquiryDetails({
//   //       ...enquiryDetails,
//   //       exportpreperationcharges: enquiryDetails.soexchangerate * enquiryDetails.exportpreperationchargescurrency,
//   //     });
//   //   }, [enquiryDetails.soexchangerate, enquiryDetails.exportpreperationchargescurrency]);

//   useEffect(() => {
//     let netTotal = 0;
//     let netTotalCurrency = 0;

//     for (let i = 0; i < enquiryDetails?.salesOrderItems?.length; i++) {
//       netTotal += enquiryDetails?.salesOrderItems[i]?.totalinr;
//       netTotalCurrency += enquiryDetails?.salesOrderItems[i]?.totalcurrency;
//     }

//     setEnquiryDetails({
//       ...enquiryDetails,
//       netamount: netTotal,
//       netamountcurrency: netTotalCurrency,
//     });
//   }, [enquiryDetails?.salesOrderItems?.length]);

//   useEffect(() => {
//     console.log("Updating grand total with:", enquiryDetails.netamountcurrency, enquiryDetails.exportpreperationchargescurrency);
//     handleGrandTotalCurrency(enquiryDetails.netamountcurrency, enquiryDetails.exportpreperationchargescurrency);
//   }, [enquiryDetails.exportpreperationchargescurrency, enquiryDetails.netamountcurrency]);

//   useEffect(() => {
//     handleGrandTotalInr(enquiryDetails.netamount, enquiryDetails.exportpreperationcharges);
//   }, [enquiryDetails.netamount, enquiryDetails.exportpreperationcharges]);

//   useEffect(() => {
//     let product = enquiryDetails.soexchangerate * enquiryDetails.exportpreperationchargescurrency;
//     setEnquiryDetails({
//       ...enquiryDetails,
//       exportpreperationcharges: product,
//     });
//   }, [enquiryDetails.soexchangerate]);

//   useEffect(() => {
//     const row = enquiryData?.salesOrderItems?.map((data) => ({
//       id: data?.id,
//       product: {
//         id: data?.product?.id,
//       },
//       description: data?.product?.description,
//       productremarks: data?.productremarks,
//       itemcode: data?.itemcode,
//       hsnsacno: data?.hsnsacno,
//       serialnumber: data?.serialnumber,
//       modelnumber: data?.modelnumber,
//       partno: data?.partno,
//       moc: data?.moc,
//       uom: data?.uom,
//       currency: data?.currency,
//       quantity: data?.quantity,
//       unitratecurrency: data?.unitratecurrency,
//       totalcurrency: data?.totalcurrency,
//       exchangerate: data?.exchangerate,
//       unitrateinr: data?.unitrateinr,
//       totalinr: data?.totalinr,
//     }));
//     setEnquiryDetails({
//       ...enquiryDetails,
//       salesordertype: "Manufacturing",
//       salesordercategory: "International",
//       branch: {
//         id: enquiryData?.branch?.id,
//       },
//       warehouse: {
//         id: enquiryData?.warehouse?.id,
//       },
//       sodate: enquiryData?.sodate,
//       amendmentno: enquiryData?.amendmentno,
//       amendmentdate: enquiryData?.amendmentdate,
//       customer: {
//         id: enquiryData?.customer?.id,
//       },
//       contactperson: enquiryData?.contactperson,
//       contactno: enquiryData?.contactno,
//       email: enquiryData?.email,
//       customeraddress: {
//         id: enquiryData?.customeraddress?.id,
//       },
//       customerpono: enquiryData?.customerpono,
//       customerpodate: enquiryData?.customerpodate,
//       quotationno: enquiryData?.quotationno,
//       quotationdate: enquiryData?.quotationdate,
//       netamountcurrency: enquiryData?.netamountcurrency,
//       netamount: enquiryData?.netamount,
//       exportpreperationchargescurrency: enquiryData?.exportpreperationchargescurrency,
//       exportpreperationcharges: enquiryData?.exportpreperationcharges,
//       grandtotalcurrency: enquiryData?.grandtotalcurrency,
//       grandtotalinr: enquiryData?.grandtotalinr,
//       salesOrderItems: row,
//       socurrency: enquiryData?.socurrency,
//       soexchangerate: enquiryData?.soexchangerate,
//       sono: enquiryData?.sono,
//       status: enquiryData?.status,
//       quotationid: enquiryData?.quotationid,
//       deliveryterm: enquiryData?.deliveryterm,
//       incoterm: enquiryData?.incoterm,
//       paymentterm: enquiryData?.paymentterm,
//     });

//     setBranchValue({ value: enquiryData?.branch?.id, label: enquiryData?.branch?.branchname });
//     setWarehouseValue({ value: enquiryData?.warehouse?.id, label: enquiryData?.warehouse?.warehousename });
//     setCustomerNameValue({ value: enquiryData?.customer?.id, label: enquiryData?.customer?.companyname });
//     setCustomerAddressValue({ value: enquiryData?.customerAddressValue?.id, label: enquiryData?.customeraddress?.customeraddress });

//     getCustomerAddress(enquiryData?.customeraddress?.id);
//   }, []);

//   console.log(enquiryDetails);
//   return (
//     <Form>
//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Branch</Form.Label>
//             <Select
//               isDisabled
//               options={branchOptions}
//               onChange={(event) => handleFormChange(event, "branch")}
//               onInputChange={(event) => {
//                 setBranchSearch(event);
//               }}
//               value={branchValue}
//             />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Warehouse</Form.Label>
//             <Select
//               isDisabled
//               options={warehouseOptions}
//               onChange={(event) => handleFormChange(event, "warehouse")}
//               onInputChange={(event) => {
//                 setWarehouseSearch(event);
//               }}
//               value={warehouseValue}
//             />
//           </Form.Group>
//         </Col>
//       </Row>
//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Sales Order No.</Form.Label>
//             <Form.Control disabled type="text" name="sodate" value={enquiryDetails.sono} onChange={handleFormChange} />
//           </Form.Group>
//         </Col>

//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Sales Order Date</Form.Label>
//             <Form.Control disabled type="date" name="sodate" value={enquiryDetails.sodate} onChange={handleFormChange} />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Amendment Date</Form.Label>
//             <Form.Control disabled type="date" name="amendmentdate" value={enquiryDetails.amendmentdate} onChange={handleFormChange} />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Amendment No.</Form.Label>
//             <Form.Control disabled type="text" name="amendmentno" value={enquiryDetails.amendmentno} onChange={handleFormChange} placeholder="Amendment No." />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col>
//           <Form.Group>
//             <Form.Label>Customer Name</Form.Label>
//             <Select
//               isDisabled
//               options={customerOptions}
//               onChange={(event) => handleFormChange(event, "customer")}
//               onInputChange={(event) => {
//                 setCustomerSearch(event);
//               }}
//               value={customerNameValue}
//             />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Contact Person</Form.Label>
//             <Form.Control value={enquiryDetails.contactperson} disabled />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Contact Number</Form.Label>
//             <Form.Control value={enquiryDetails.contactno} disabled />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Email</Form.Label>
//             <Form.Control value={enquiryDetails.email} disabled />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Payment Terms</Form.Label>
//             <Form.Control disabled type="text" name="paymentterm" value={enquiryDetails.paymentterm} onChange={handleFormChange} placeholder="Payment Terms" />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Customer Address</Form.Label>
//             <Select isDisabled value={customerAddressValue} options={customerDetailsOptions} onChange={(event) => handleFormChange(event, "customeraddress")} />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Customer PO NO.</Form.Label>
//             <Form.Control disabled type="text" name="customerpono" value={enquiryDetails.customerpono} onChange={handleFormChange} placeholder="Customer PO NO." />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Customer PO Date</Form.Label>
//             <Form.Control disabled type="date" name="customerpodate" value={enquiryDetails.customerpodate} onChange={handleFormChange} placeholder="Customer PO Date" />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Quotation NO.</Form.Label>
//             <Form.Control disabled type="text" name="quotationno" value={enquiryDetails.quotationno} onChange={handleFormChange} placeholder="Quotation NO." />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Quotation Date</Form.Label>
//             <Form.Control disabled type="date" name="quotationdate" value={enquiryDetails.quotationdate} onChange={handleFormChange} placeholder="Quotation Date" />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Delivery Terms</Form.Label>
//             <Form.Control disabled type="text" name="deliveryterm" value={enquiryDetails.deliveryterm} onChange={handleFormChange} placeholder="Delivery Terms" />
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Inco Terms</Form.Label>
//             <Form.Control disabled type="text" name="incoterm" value={enquiryDetails.incoterm} onChange={handleFormChange} placeholder="Inco Terms" />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Currency</Form.Label>
//             <Form.Select disabled onChange={(e) => handleFormChange(e, "socurrency")} name="socurrency" value={enquiryDetails.socurrency}>
//               <option>Select Currency</option>
//               <option value="$ (USD)">$ (USD)</option>
//               <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
//               <option value="GBP (Pounds)">GBP (Pounds)</option>
//               <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
//               <option value="₹ (INR)">₹ (INR)</option>
//             </Form.Select>
//           </Form.Group>
//         </Col>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Exchange Rate (Rs)/Currency</Form.Label>
//             <Form.Control disabled type="number" onChange={(e) => handleFormChange(e, "soexchangerate")} value={enquiryDetails.soexchangerate} name="soexchangerate" />
//           </Form.Group>
//         </Col>
//       </Row>

//       <Row>
//         <Col md="6">
//           <Form.Group>
//             <Form.Label>Status</Form.Label>
//             <Form.Control disabled type="text" onChange={(e) => handleFormChange(e, "soexchangerate")} value={enquiryDetails.status} name="soexchangerate" />
//           </Form.Group>
//         </Col>
//       </Row>

//       <br></br>
//       <hr></hr>

//       <br></br>
//       <div className="table-responsive">
//         <Table>
//           <thead>
//             <tr>
//               <th>Product Description</th>
//               <th>Product Code</th>
//               <th>HSN Code</th>
//               <th>Serial No.</th>
//               <th>Model No.</th>
//               <th>Part No.</th>
//               <th>MOC</th>
//               <th>unit of measurement</th>
//               <th>Currency</th>
//               <th>Quantity</th>
//               <th>Unit Rate (Currency)</th>
//               <th>Total (Currency) </th>
//               <th>Exchange Rate (Rs)/Currency</th>
//               <th>Unit Rate (Rs)</th>
//               <th>Total (Rs)</th>
//             </tr>
//           </thead>
//           <tbody>
//             {enquiryDetails.salesOrderItems.map((item, index) => (
//               <tr key={index}>
//                 <td>
//                   {item.description}
//                   <Form.Control
//                     disabled
//                     as="textarea"
//                     rows={2}
//                     className="remarks"
//                     type="text"
//                     value={item.productremarks}
//                     onChange={(e) => {
//                       const newRows = [...enquiryDetails.salesOrderItems];
//                       newRows[index].productremarks = e.target.value;
//                       setEnquiryDetails({ ...enquiryDetails, salesOrderItems: newRows });
//                     }}
//                     placeholder="Enter item remarks"
//                     contentEditable="true"
//                   />
//                 </td>
//                 <td>{item.itemcode}</td>
//                 <td>{item.hsnsacno}</td>
//                 <td>{item.serialnumber}</td>
//                 <td>{item.modelnumber}</td>
//                 <td>{item.partno}</td>
//                 <td>{item.moc}</td>
//                 <td>
//                   <Form.Select
//                     className="uom"
//                     disabled
//                     value={item.uom ? item.uom.toLowerCase() : ""}
//                     onChange={(event) => {
//                       // Update the unit of measurement in the respective item
//                       const newItems = [...enquiryDetails.enquiryItems];
//                       newItems[index].uom = event.target.value; // Store the selected value as is
//                       setEnquiryDetails({ ...enquiryDetails, enquiryItems: newItems });
//                     }}
//                   >
//                     <option value="">Select UOM</option>
//                     <option value="bot (bottle)">Bot (Bottle)</option>
//                     <option value="ctn (carton)">Ctn (Carton)</option>
//                     <option value="days">Days</option>
//                     <option value="ft (feet)">Ft (FEET)</option>
//                     <option value="hrs (hour)">Hrs (Hour)</option>
//                     <option value="kg (kilogram)">Kg (Kilogram)</option>
//                     <option value="kgs.">Kgs.</option>
//                     <option value="ltr (littre)">Ltr (Littre)</option>
//                     <option value="mtr">Mtr</option>
//                     <option value="nos (number)">Nos (Number)</option>
//                     <option value="pil (pail)">Pil (Pail)</option>
//                     <option value="pkt (packet)">Pkt (Packet)</option>
//                     <option value="set (sets)">Set (Sets)</option>
//                     <option value="pcs (pcs)">Pcs (Pcs)</option>
//                   </Form.Select>
//                 </td>
//                 <td>
//                   <Form.Control className="uom" value={item?.currency} disabled />
//                 </td>
//                 <td>
//                   <Form.Control min="0" className="uom" value={item.quantity} disabled type="number" onChange={(event) => handleQuantityChange(event, index)} />
//                 </td>

//                 <td>
//                   <Form.Control min="0" className="uom" type="number" disabled onChange={(event) => handleUnitRateChange(event, index)} value={item.unitratecurrency} />
//                 </td>

//                 <td>
//                   <Form.Control min="0" className="uom" type="number" value={item.totalcurrency} disabled />
//                 </td>

//                 <td>
//                   <Form.Control min="0" className="uom" type="number" value={item?.exchangerate} disabled onChange={(event) => handleExchangeRateChange(event, index)} />
//                 </td>

//                 <td>
//                   <Form.Control min="0" className="uom" type="number" value={item.unitrateinr} disabled />
//                 </td>

//                 <td>
//                   <Form.Control style={{ width: "70px" }} min="0" className="uom" type="text" disabled value={item.totalinr} />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//           <tfoot>
//             <tr>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td>Net Total (Currency)</td>
//               <td>
//                 <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.netamountcurrency} />
//               </td>
//               <td></td>
//               <td>Net Total (Rs)</td>
//               <td>
//                 <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.netamount} />
//               </td>
//               <td></td>
//             </tr>

//             <tr>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td>Export Prepration Charges (Currency)</td>
//               <td>
//                 <Form.Control disabled min="0" className="uom" type="number" onChange={(event) => handleMiscChargesCurrency(event)} value={enquiryDetails.exportpreperationchargescurrency} />
//               </td>
//               <td></td>
//               <td>Export Prepration Charges (Rs)</td>
//               <td>
//                 <Form.Control min="0" className="uom" type="number" disabled onChange={(event) => handleMiscCharges(event)} value={enquiryDetails.exportpreperationcharges} />
//               </td>
//               <td></td>
//             </tr>

//             <tr>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td></td>
//               <td>Grand Total (Currency)</td>
//               <td>
//                 <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.grandtotalcurrency} />
//               </td>
//               <td></td>
//               <td>Grand Total (Rs)</td>
//               <td>
//                 <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.grandtotalinr} />
//               </td>
//               <td></td>
//             </tr>
//           </tfoot>
//         </Table>
//       </div>
//     </Form>
//   );
// };

// export default ViewAraiMFGSO;  






import React, { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Badge, Container, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../../services/Api";
import { authHeader } from "../../../services/auth-header";
import { FaArrowLeft } from "react-icons/fa";

const ViewAraiMFGSO = ({ enquiryData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [soDetails, setSoDetails] = useState(null);
  const [customerAddress, setCustomerAddress] = useState(null);
  const [billToAddress, setBillToAddress] = useState(null);
  const [shipToAddress, setShipToAddress] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (enquiryData) {
      setSoDetails({
        sono: enquiryData?.sono,
        sodate: enquiryData?.sodate,
        salesordertype: enquiryData?.salesordertype,
        salesordercategory: enquiryData?.salesordercategory,
        amendmentno: enquiryData?.amendmentno,
        amendmentdate: enquiryData?.amendmentdate,
        branch: enquiryData?.branch,
        warehouse: enquiryData?.warehouse,
        customer: enquiryData?.customer,
        contactperson: enquiryData?.contactperson,
        contactno: enquiryData?.contactno,
        email: enquiryData?.email,
        customerpono: enquiryData?.customerpono,
        customerpodate: enquiryData?.customerpodate,
        quotationno: enquiryData?.quotationno,
        quotationdate: enquiryData?.quotationdate,
        deliveryterm: enquiryData?.deliveryterm,
        incoterm: enquiryData?.incoterm,
        paymentterm: enquiryData?.paymentterm,
        socurrency: enquiryData?.socurrency,
        soexchangerate: enquiryData?.soexchangerate,
        status: enquiryData?.status,
        netamountcurrency: enquiryData?.netamountcurrency,
        netamount: enquiryData?.netamount,
        exportpreperationchargescurrency: enquiryData?.exportpreperationchargescurrency,
        exportpreperationcharges: enquiryData?.exportpreperationcharges,
        grandtotalcurrency: enquiryData?.grandtotalcurrency,
        grandtotalinr: enquiryData?.grandtotalinr,
      });

      setCustomerAddress(enquiryData?.customeraddress);
      setBillToAddress(enquiryData?.billto);
      setShipToAddress(enquiryData?.shipto);

      if (enquiryData?.salesOrderItems && enquiryData.salesOrderItems.length > 0) {
        setRows(enquiryData.salesOrderItems.map(item => ({
          description: item.product?.description || '-',
          productremarks: item.productremarks || "-",
          itemcode: item.itemcode || item.product?.itemcode || "-",
          hsnsacno: item.hsnsacno || item.product?.hsnsacno || "-",
          serialnumber: item.serialnumber || "-",
          modelnumber: item.modelnumber || "-",
          partno: item.partno || "-",
          moc: item.moc || "-",
          uom: item.uom || "-",
          currency: item.currency || "-",
          quantity: item.quantity || 0,
          unitratecurrency: item.unitratecurrency || 0,
          totalcurrency: item.totalcurrency || 0,
          exchangerate: item.exchangerate || 0,
          unitrateinr: item.unitrateinr || 0,
          totalinr: item.totalinr || 0,
        })));
      }
      setIsLoading(false);
    }
  }, [enquiryData]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(value || 0);

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '0.00';
    return parseFloat(value).toFixed(2);
  };

  const getAddressString = (address) => {
    if (!address) return '-';
    return [
      address.customeraddress,
      address.city?.cityname,
      address.state?.statename,
      address.pincode,
      address.country?.countryname
    ].filter(Boolean).join(', ');
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Active': return 'success';
      case 'Draft': return 'secondary';
      case 'Pending': return 'warning';
      case 'Completed': return 'success';
      case 'Cancelled': return 'danger';
      default: return 'info';
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!soDetails) {
    return <div className="alert alert-danger text-center mt-4">Sales Order not found</div>;
  }

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">MANUFACTURING SALES ORDER - VIEW</h5>
            <div>
              <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
                <FaArrowLeft className="me-1" />
                Back
              </Button>
            </div>
          </div>

          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">SO Number</small>
                <div className="fw-bold">{soDetails.sono || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">SO Date</small>
                <div className="fw-bold">{formatDate(soDetails.sodate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">Currency</small>
                <div className="fw-bold">{soDetails.socurrency || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge bg={getStatusBadge(soDetails.status)} className="px-2 py-1">
                    {soDetails.status || '-'}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Branch & Warehouse */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Branch & Warehouse Details</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={6}>
              <small className="text-muted">Branch</small>
              <div className="fw-bold">{soDetails.branch?.branchname || '-'}</div>
            </Col>
            <Col md={6}>
              <small className="text-muted">Warehouse</small>
              <div className="fw-bold">{soDetails.warehouse?.warehousename || '-'}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Sales Order Details */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Sales Order Details</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Amendment No</small>
              <div className="fw-bold">{soDetails.amendmentno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Amendment Date</small>
              <div className="fw-bold">{formatDate(soDetails.amendmentdate)}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Exchange Rate (₹/Currency)</small>
              <div className="fw-bold">{soDetails.soexchangerate || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Customer PO No</small>
              <div className="fw-bold">{soDetails.customerpono || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Customer PO Date</small>
              <div className="fw-bold">{formatDate(soDetails.customerpodate)}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Quotation No</small>
              <div className="fw-bold">{soDetails.quotationno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Quotation Date</small>
              <div className="fw-bold">{formatDate(soDetails.quotationdate)}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Delivery Term</small>
              <div className="fw-bold">{soDetails.deliveryterm || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Inco Term</small>
              <div className="fw-bold">{soDetails.incoterm || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Payment Term</small>
              <div className="fw-bold">{soDetails.paymentterm || '-'}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Customer Information */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Customer Information</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Company Name</small>
              <div className="fw-bold">{soDetails.customer?.companyname || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Contact Person</small>
              <div className="fw-bold">{soDetails.contactperson || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">GST No</small>
              <div className="fw-bold">{soDetails.customer?.gstno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Phone</small>
              <div className="fw-bold">{soDetails.contactno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Email</small>
              <div className="fw-bold">{soDetails.email || '-'}</div>
            </Col>
            <Col md={12}>
              <small className="text-muted">Address</small>
              <div className="fw-bold">{getAddressString(customerAddress)}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Bill To & Ship To */}
      {(billToAddress || shipToAddress) && (
        <div className="shadow-sm border rounded bg-white mb-3">
          <div className="bg-light py-2 px-3 border-bottom">
            <h6 className="mb-0 fw-bold">Billing & Shipping Information</h6>
          </div>
          <div className="p-3">
            <Row className="g-3">
              {billToAddress && (
                <Col md={6}>
                  <div className="border-start border-3 border-primary ps-3">
                    <small className="text-muted">Bill To</small>
                    <div className="fw-bold">{getAddressString(billToAddress)}</div>
                  </div>
                </Col>
              )}
              {shipToAddress && (
                <Col md={6}>
                  <div className="border-start border-3 border-success ps-3">
                    <small className="text-muted">Ship To</small>
                    <div className="fw-bold">{getAddressString(shipToAddress)}</div>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </div>
      )}

      {/* Sales Order Items */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Sales Order Items</h6>
        </div>
        <div className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Description</th>
                  <th className="fw-bold py-2">Item Code</th>
                  <th className="fw-bold py-2">HSN Code</th>
                  <th className="fw-bold py-2">Serial No</th>
                  <th className="fw-bold py-2">Model No</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">MOC</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                  <th className="fw-bold py-2">Currency</th>
                  <th className="fw-bold py-2 text-center">Qty</th>
                  <th className="fw-bold py-2 text-end">Unit Rate (Curr)</th>
                  <th className="fw-bold py-2 text-end">Total (Curr)</th>
                  <th className="fw-bold py-2 text-end">Exch Rate</th>
                  <th className="fw-bold py-2 text-end">Unit Rate (₹)</th>
                  <th className="fw-bold py-2 text-end">Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{row.description || '-'}</div>
                      {row.productremarks && row.productremarks !== '-' && (
                        <div className="text-muted small mt-1">
                          <small><strong>Remarks:</strong> {row.productremarks}</small>
                        </div>
                      )}
                    </td>
                    <td>{row.itemcode || '-'}</td>
                    <td>{row.hsnsacno || '-'}</td>
                    <td>{row.serialnumber || '-'}</td>
                    <td>{row.modelnumber || '-'}</td>
                    <td>{row.partno || '-'}</td>
                    <td>{row.moc || '-'}</td>
                    <td className="text-center">{row.uom || '-'}</td>
                    <td>{row.currency || '-'}</td>
                    <td className="text-center">{row.quantity || '0'}</td>
                    <td className="text-end">{formatNumber(row.unitratecurrency)}</td>
                    <td className="text-end">{formatNumber(row.totalcurrency)}</td>
                    <td className="text-end">{formatNumber(row.exchangerate)}</td>
                    <td className="text-end">{formatCurrency(row.unitrateinr)}</td>
                    <td className="text-end fw-semibold">{formatCurrency(row.totalinr)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light">
                <tr>
                  <td colSpan="11" className="text-end fw-bold py-2">Net Total (Currency):</td>
                  <td colSpan="2" className="text-end fw-bold py-2">{formatNumber(soDetails.netamountcurrency)}</td>
                  <td colSpan="3" className="text-end fw-bold py-2">Net Total (₹): {formatCurrency(soDetails.netamount)}</td>
                </tr>
                <tr>
                  <td colSpan="11" className="text-end fw-bold py-2">Export Prep. Charges (Currency):</td>
                  <td colSpan="2" className="text-end fw-bold py-2">{formatNumber(soDetails.exportpreperationchargescurrency)}</td>
                  <td colSpan="3" className="text-end fw-bold py-2">Export Prep. Charges (₹): {formatCurrency(soDetails.exportpreperationcharges)}</td>
                </tr>
                <tr>
                  <td colSpan="11" className="text-end fw-bold py-2">Grand Total (Currency):</td>
                  <td colSpan="2" className="text-end fw-bold py-2">{formatNumber(soDetails.grandtotalcurrency)}</td>
                  <td colSpan="3" className="text-end fw-bold py-2 text-primary">Grand Total (₹): {formatCurrency(soDetails.grandtotalinr)}</td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
          <FaArrowLeft className="me-1" />
          Back to List
        </Button>
      </div>
    </Container>
  );
};

export default ViewAraiMFGSO;
